<template>
  <div class="psm-contact-popup">
    <div class="popup-header-container sac__font-20" medium>
      PSM Contact Information
      <button
        type="button"
        @click="close"
      >
        <span class="icon-luc-X sac__font-24" />
      </button>
    </div>
    <div class="popup-body-container">
      <a
        class="sac__font-18 f-primary underline"
        :href="`mailto:${psm.email}`"
      >
        {{ psm.email }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PSMContactPopup',
  props: {
    psm: Object,
    close: Function,
  },
  mounted() {
    document.querySelector(':not(.psm-contact-popup').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(.psm-contact-popup').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    closeOnClick(e) {
      if (!e.target.closest('.psm-button') && !e.target.closest('.psm-contact-popup')) {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss">
.psm-contact-popup {
  position: absolute;
  top: 36px;
  right: 0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background-color: $WHITE;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  .popup-header-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }
}
</style>
